import React from 'react';
import { SearchResultGroup } from './SearchResultGroup';
import { RecentItems } from './RecentItems';

export function SearchResults({
  results,
  query,
  recent,
  onClearRecent,
  onSelect,
  scopeBlocksAll,
  effectiveModuleKeySet = null,
}) {
  const groups = Array.isArray(results?.groups) ? results.groups : [];
  const hasQuery = !!String(query || '').trim();

  if (!hasQuery) {
    return (
      <div className="kp-search-results">
        <RecentItems recent={recent} onClear={onClearRecent} onSelect={onSelect} effectiveModuleKeySet={effectiveModuleKeySet} />
      </div>
    );
  }

  if (groups.length === 0) {
    return (
      <div className="kp-search-results">
        <div className="kp-search-empty">
          {scopeBlocksAll
            ? `Det här filtret stöds inte än — sökning utanför moduler kommer i en kommande version.`
            : `Inga träffar för "${query}"`}
        </div>
      </div>
    );
  }

  return (
    <div className="kp-search-results">
      {groups.map((g) => (
        <SearchResultGroup
          key={g.scope}
          group={g}
          query={query}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
